import cart from "./cart";
import login from "./login";
import myFav from "./myFav";
import order from "./order";
import product from "./product";
import validate from "./validate";
import countryList from "./countryList";
import browsingHistory from "./browsingHistory";
import recommendation from "./recommendation";
import myBag from "./myBag";
import addresses from "./addresses";
import customer from "./customer";
import loading from "./loading";
import pickUpInStore from "./pickUpInStore";
import loginPopup from "./loginPopup";
import showMiniCart from "./showMiniCart";
import errorPage from "./errorPage";
import register from "./register";
import mobileMenu from "./mobileMenu";
import enlargeImage from "./enlargeImage";
import chosenFilter from "./chosenFilter";
import scaleProduct from "./scaleProduct";
import searchKeywords from "./searchKeywords";
import sortByFitler from "./sortByFitler";
import coupon from "./coupon";

export {
    cart,
    login,
    myFav,
    order,
    product,
    validate,
    countryList,
    browsingHistory,
    recommendation,
    myBag,
    addresses,
    customer,
    loading,
    pickUpInStore,
    loginPopup,
    showMiniCart,
    errorPage,
    register,
    mobileMenu,
    enlargeImage,
    chosenFilter,
    scaleProduct,
    searchKeywords,
    sortByFitler,
    coupon
};
